import {
	PATIENT_QUESTIONNAIRE_ACTION_TYPES,
	PatientQuestionnaireActions,
	PatientQuestionnaireFilters,
	PatientQuestionnaireState,
} from '../../../../types/questionnaire'

const initialState: PatientQuestionnaireState = {
	questionnaires: [],
	filter: PatientQuestionnaireFilters.SENT,
}

export default (
	state = initialState,
	action: PatientQuestionnaireActions
): PatientQuestionnaireState => {
	switch (action.type) {
		case PATIENT_QUESTIONNAIRE_ACTION_TYPES.PATIENT_QUESTIONNAIRE_SET: {
			return {
				...state,
				questionnaires: action.payload,
			}
		}

		case PATIENT_QUESTIONNAIRE_ACTION_TYPES.PATIENT_QUESTIONNAIRE_SET_FILTER: {
			return {
				...state,
				filter: action.payload,
			}
		}

		default: {
			return state
		}
	}
}
